import React, { useEffect, useState } from "react";
import { subscribeLoader } from "./loaderService";

const GlobalLoader = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const unsubscribe = subscribeLoader(setVisible);
        return () => unsubscribe();
    }, []);

    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-white/70 backdrop-blur-sm">
            <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
    );
};

export default GlobalLoader;
